module.exports = __webpack_public_path__ + "img/f3-3-r.dab6ddb8.png";